export const ViewMode = {
  ReviewComments: 'review-comments',
  ThreadPreviews: 'thread-previews',
  IssueComments: 'issue-comments',
} as const

export type CommentsPanelViewMode = (typeof ViewMode)[keyof typeof ViewMode]
